import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isModernUI, setIsModernUI] = useState(true);

  const toggleTheme = () => {
    setIsModernUI(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isModernUI, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};